import AutoConfiguration from "./AutoConfiguration";

export default AutoConfiguration;
